export const GENERATE_PDF_DATA_SERVICE_I18N = {
  ocResults: {
    teeth: {
      description: $localize`:@@data.util.generatePdf.oc.teeth.description:残存歯`,
      values: {
        lessThan10: $localize`:@@data.util.generatePdf.oc.teeth.lessThan10:<10本`,
        between10And20: $localize`:@@data.util.generatePdf.oc.teeth.between10And20:10-20本`,
        between21And25: $localize`:@@data.util.generatePdf.oc.teeth.between21And25:21-25本`,
        moreThan25: $localize`:@@data.util.generatePdf.oc.teeth.moreThan25:>25本`,
      },
    },
    denture: {
      description: $localize`:@@data.util.generatePdf.oc.denture.description:義歯安定性`,
      values: {
        slip: $localize`:@@data.util.generatePdf.oc.denture.slip:義歯滑落`,
        movement: $localize`:@@data.util.generatePdf.oc.denture.movement:義歯動揺`,
        stable: $localize`:@@data.util.generatePdf.oc.denture.stable:義歯安定`,
        notUsed: $localize`:@@data.util.generatePdf.oc.denture.notUsed:義歯不使用`,
      },
    },
    oralHygiene: {
      description: $localize`:@@data.util.generatePdf.oc.oralHygiene.description:口腔環境`,
      values: {
        severeContamination: $localize`:@@data.util.generatePdf.oc.oralHygiene.severeContamination:著明な汚染`,
        contamination: $localize`:@@data.util.generatePdf.oc.oralHygiene.contamination:汚染あり`,
        tongueCoatingCaries: $localize`:@@data.util.generatePdf.oc.oralHygiene.tongueCoatingCaries:舌苔あり齲歯あり`,
        noContamination: $localize`:@@data.util.generatePdf.oc.oralHygiene.noContamination:汚染なし`,
      },
    },
    articulationLevel: {
      description: $localize`:@@data.util.generatePdf.oc.articulationLevel.description:発話能力\n（発話明瞭度）`,
      values: {
        unintelligible: $localize`:@@data.util.generatePdf.oc.articulationLevel.unintelligible:全く聞き取り不能（5）`,
        sometimes: $localize`:@@data.util.generatePdf.oc.articulationLevel.sometimes:時々わかる（3-4）`,
        sometimesNot: $localize`:@@data.util.generatePdf.oc.articulationLevel.sometimesNot:時々わからない（2）`,
        clear: $localize`:@@data.util.generatePdf.oc.articulationLevel.clear:よくわかる（1）`,
      },
    },
    rightArm: {
      description: $localize`:@@data.util.generatePdf.oc.rightArm.description:上肢機能・右\n（MMT、SIAS）`,
      values: {
        almostImmobile: $localize`:@@data.util.generatePdf.oc.rightArm.almostImmobile:≦ほとんど動かない（0-1）`,
        canElevate: $localize`:@@data.util.generatePdf.oc.rightArm.canElevate:挙上可能（2-3）`,
        weakResistance: $localize`:@@data.util.generatePdf.oc.rightArm.weakResistance:弱い抵抗運動可能（3-4）`,
        strongResistance: $localize`:@@data.util.generatePdf.oc.rightArm.strongResistance:強い抵抗運動可能（5）`,
      },
    },
    leftArm: {
      description: $localize`:@@data.util.generatePdf.oc.leftArm.description:上肢機能・左\n（MMT、SIAS）`,
      values: {
        almostImmobile: $localize`:@@data.util.generatePdf.oc.leftArm.almostImmobile:≦ほとんど動かない（0-1）`,
        canElevate: $localize`:@@data.util.generatePdf.oc.leftArm.canElevate:挙上可能（2-3）`,
        weakResistance: $localize`:@@data.util.generatePdf.oc.leftArm.weakResistance:弱い抵抗運動可能（3-4）`,
        strongResistance: $localize`:@@data.util.generatePdf.oc.leftArm.strongResistance:強い抵抗運動可能（5）`,
      },
    },
    disabilityLevel: {
      description: $localize`:@@data.util.generatePdf.oc.disabilityLevel.description:身体機能\n（障害高齢者の生活自立度）`,
      values: {
        bedridden: $localize`:@@data.util.generatePdf.oc.disabilityLevel.bedridden:ベッド上寝たきり（C）`,
        wheelchair: $localize`:@@data.util.generatePdf.oc.disabilityLevel.wheelchair:車いす乗車可能（B）`,
        bedboundWalkable: $localize`:@@data.util.generatePdf.oc.disabilityLevel.bedboundWalkable:臥床がち、歩行可能（A）`,
        independent: $localize`:@@data.util.generatePdf.oc.disabilityLevel.independent:独力で外出可能（J～）`,
      },
    },
    cognitiveLevel: {
      description: $localize`:@@data.util.generatePdf.oc.cognitiveLevel.description:認知機能\n（認知症高齢者の生活自立度）`,
      values: {
        requiresMonitoring: $localize`:@@data.util.generatePdf.oc.cognitiveLevel.requiresMonitoring:常時監視必要（IV-M）`,
        prominent: $localize`:@@data.util.generatePdf.oc.cognitiveLevel.prominent:症状目立つ（III）`,
        occasional: $localize`:@@data.util.generatePdf.oc.cognitiveLevel.occasional:時々症状あり（II）`,
        noSymptoms: $localize`:@@data.util.generatePdf.oc.cognitiveLevel.noSymptoms:症状なし（I～）`,
      },
    },
  },
  gcResults: {
    consciousnessLevel: {
      description: $localize`:@@data.util.generatePdf.gc.consciousnessLevel.description:意識レベル`,
      values: {
        noResponse: $localize`:@@data.util.generatePdf.gc.consciousnessLevel.noResponse:無反応`,
        painResponse: $localize`:@@data.util.generatePdf.gc.consciousnessLevel.painResponse:痛みに反応`,
        voiceResponse: $localize`:@@data.util.generatePdf.gc.consciousnessLevel.voiceResponse:声掛けに反応`,
        awake: $localize`:@@data.util.generatePdf.gc.consciousnessLevel.awake:覚醒`,
      },
    },
    temperature: {
      description: $localize`:@@data.util.generatePdf.gc.temperature.description:体温`,
      values: {
        over40: $localize`:@@data.util.generatePdf.gc.temperature.over40:≥ 40.0 ℃ `,
        between385And399: $localize`:@@data.util.generatePdf.gc.temperature.between385And399:38.5-39.9 ℃  `,
        between375And384: $localize`:@@data.util.generatePdf.gc.temperature.between375And384:37.5-38.4 ℃`,
        under375: $localize`:@@data.util.generatePdf.gc.temperature.under375:< 37.5 ℃`,
      },
    },
    pulseLevel: {
      description: $localize`:@@data.util.generatePdf.gc.pulseLevel.description:脈拍数`,
      values: {
        over130: $localize`:@@data.util.generatePdf.gc.pulseLevel.over130:>130bpm`,
        between111And130: $localize`:@@data.util.generatePdf.gc.pulseLevel.between111And130:111-130bpm`,
        between91And110: $localize`:@@data.util.generatePdf.gc.pulseLevel.between91And110:91-110bpm`,
        under90: $localize`:@@data.util.generatePdf.gc.pulseLevel.under90:≦ 90 bpm`,
      },
    },
    spo2: {
      description: $localize`:@@data.util.generatePdf.gc.spo2.description:SpO2`,
      values: {
        under91: $localize`:@@data.util.generatePdf.gc.spo2.under91:≦ 91%`,
        between92And93: $localize`:@@data.util.generatePdf.gc.spo2.between92And93:92-93%`,
        between94And95: $localize`:@@data.util.generatePdf.gc.spo2.between94And95:94-95%`,
        over96: $localize`:@@data.util.generatePdf.gc.spo2.over96:≧ 96%`,
      },
    },
    breathLevel: {
      description: $localize`:@@data.util.generatePdf.gc.breathLevel.description:呼吸回数`,
      values: {
        over30: $localize`:@@data.util.generatePdf.gc.breathLevel.over30:≧ 30回/分`,
        between25And29: $localize`:@@data.util.generatePdf.gc.breathLevel.between25And29:25-29回/分`,
        between21And24: $localize`:@@data.util.generatePdf.gc.breathLevel.between21And24:21-24回/分`,
        under20: $localize`:@@data.util.generatePdf.gc.breathLevel.under20:≦ 20回/分`,
      },
    },
    onOxygen: {
      description: $localize`:@@data.util.generatePdf.gc.onOxygen.description:酸素療法`,
      values: {
        highFlow: $localize`:@@data.util.generatePdf.gc.onOxygen.highFlow:PPV、HFNC、高流量`,
        lowFlow: $localize`:@@data.util.generatePdf.gc.onOxygen.lowFlow:低流量`,
        tracheostomy: $localize`:@@data.util.generatePdf.gc.onOxygen.tracheostomy:気管切開`,
        none: $localize`:@@data.util.generatePdf.gc.onOxygen.none:なし`,
      },
    },
    sputum: {
      description: $localize`:@@data.util.generatePdf.gc.sputum.description:痰`,
      values: {
        frequentSuction: $localize`:@@data.util.generatePdf.gc.sputum.frequentSuction:吸引頻回`,
        suction: $localize`:@@data.util.generatePdf.gc.sputum.suction:吸引あり`,
        rattleSelfExpectoration: $localize`:@@data.util.generatePdf.gc.sputum.rattleSelfExpectoration:痰絡み or 自己喀痰あり\n吸引なし`,
        none: $localize`:@@data.util.generatePdf.gc.sputum.none:なし`,
      },
    },
  },
  mwstResults: {
    noSwallowWithCoughOrDyspnea: $localize`:@@data.util.generatePdf.mwst.noSwallowWithCoughOrDyspnea:嚥下なし、むせるand/or呼吸切迫`,
    swallowWithDyspnea: $localize`:@@data.util.generatePdf.mwst.swallowWithDyspnea:嚥下あり、呼吸切迫`,
    swallowGoodBreathingWithCoughOrWetVoice: $localize`:@@data.util.generatePdf.mwst.swallowGoodBreathingWithCoughOrWetVoice:嚥下あり、呼吸良好、むせるand/or湿性嗄声`,
    swallowGoodBreathingNoCough: $localize`:@@data.util.generatePdf.mwst.swallowGoodBreathingNoCough:嚥下あり、呼吸良好、むせなし`,
    swallowGoodBreathingNoCoughWithRepetitive: $localize`:@@data.util.generatePdf.mwst.swallowGoodBreathingNoCoughWithRepetitive:４に加え、反復嚥下が30秒以内に２回可能`,
  },
  foodResults: {
    noSwallowWithCoughOrDyspnea: $localize`:@@data.util.generatePdf.food.noSwallowWithCoughOrDyspnea:嚥下なし、むせるand/or呼吸切迫`,
    swallowWithDyspnea: $localize`:@@data.util.generatePdf.food.swallowWithDyspnea:嚥下あり、呼吸切迫`,
    swallowGoodBreathingWithCoughOrWetVoiceAndRetention: $localize`:@@data.util.generatePdf.food.swallowGoodBreathingWithCoughOrWetVoiceAndRetention:嚥下あり、呼吸良好、むせるand/or湿性嗄声、口腔内残留中等度`,
    swallowGoodBreathingNoCough: $localize`:@@data.util.generatePdf.food.swallowGoodBreathingNoCough:嚥下あり、呼吸良好、むせなし`,
    swallowGoodBreathingNoCoughWithRepetitive: $localize`:@@data.util.generatePdf.food.swallowGoodBreathingNoCoughWithRepetitive:４に加え、反復嚥下が30秒以内に２回可能`,
  },
} as const;
